import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../util/api.service';
import { CustomHttpUrlEncodingCodec } from '../../util/codecs/encoder';
import { HeadersRequest } from '../../util/model/header-request.inteface';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OficiosService {

  public basePath = environment.basePathOrquestrador + '/serasajud-oficio/v1';

  constructor(
    protected apiService: ApiService,
    private httpClient: HttpClient
  ) { }

  public getForos(auth: string) {
    return this.apiService.get<any>(`${this.basePath}/foro`, null, this.getHeaders(auth));
  }

  public getVaras(idForo: number, auth: string) {
    return this.apiService.get<any>(`${this.basePath}/magistrado-vara`, this.buildQueryParams('idForo', idForo), this.getHeaders(auth));
  }

  public getDetalheArquivo(idArquivo: string, auth: string) {
    return this.apiService.get<any>(`${this.basePath}/arquivo/detalhe/${idArquivo}`, null, this.getHeaders(auth));
  }

  public getDownloadArquivo(idArquivo: string, auth: string) {
    return this.httpClient.get(`${this.basePath}/arquivo/${idArquivo}`, {
        observe: 'response',
        headers: {'Authorization': `Bearer ${auth}`},
        responseType: 'arraybuffer' })
        .pipe(
          map(result => {
              return {
                    blob: new Blob([result.body], {type: result.headers.get('Content-Type')}),
                    fileName: this.extraiFileName(result)
                };
              }
          )
        )
  }

  private extraiFileName(result: any) {
    return 'Response_' + new Date().getTime() + '.pdf';
  }

  private getHeaders(auth: string): Array<HeadersRequest> {
    const headers: Array<HeadersRequest> = new Array<HeadersRequest>();
    headers.push({param: 'Authorization', value: 'Bearer ' + auth});
    return headers;
  }

  private buildQueryParams(paramName: string, paramValue: any): HttpParams {
    let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
    queryParameters = queryParameters.set(paramName, paramValue);
    return queryParameters;
  }

}
